import axios from "axios";

interface IEditBookingFieldsParams {
    id: string,
    vip?: string,
    cig?: string,
    dossierNumber?: string,
    replacementPlateNumber?: string,
    flightNumber?: string
    specialConditionsAccepted?: boolean
}

export const editBookingFields = async ({ id, ...params }: IEditBookingFieldsParams): Promise<void> => {
    const response = axios.post(`/booking/book/${id}/edit`, params);
    return (await response).data;
};
